<template>
    <div class="weiqi_preview"
         :class="taskid?'pb0':''">
        <headers :title='title'></headers>
        <div class="topicSwitch">
            <h3 class="sum">共{{list.length}}题</h3>
        </div>
        <div class="question_list">
            <div class="question_item"
                 v-for="(item,index) in list"
                 :key="index">
                <template v-if="item.title_type==2">
                    <div class="title">
                        <img src="./img/icon_img3.png"
                             class="icon" />
                        <p>({{item.level_id}}K)</p>
                    </div>
                    <div class="con"
                         v-html="item.content">

                    </div>
                </template>
                <template v-else>
                    <div class="title">
                        <img src="./img/icon_img3.png"
                             class="icon" />
                        <p>({{item.level_id}}K)<span v-html="item.content"></span></p>
                    </div>
                    <div class="con">
                        <img :src="item.image_url" />
                    </div>
                </template>

                <div class="options"
                     v-if="item.title_type==2">
                    <div class="tit"
                         @click="open(item)">
                        <p>{{item.open?'收起':'展开'}}选项</p><img :src="item.open?require('./img/icon_close.png'):require('./img/icon_open.png')"
                             class="icon" />
                    </div>
                    <div class="ops"
                         v-if="item.open">
                        <div class="ops_item"
                             :class="item2.is_right?'active':''"
                             v-for="(item2,index2) in item.options"
                             :key="index2">
                            <i class="icon">{{item2.option}}</i>
                            <div v-html="item2.content"></div>
                        </div>
                    </div>
                </div>
                <div class="times"
                     v-if="!taskid">
                    <p>使用次数：{{item.send_num}}次</p>
                    <span class="btn"
                          :class="item.choise?'active':''"
                          @click="remove(item)">{{item.choise?'移除':'加入'}}</span>
                </div>
            </div>
        </div>
        <div class="next"
             v-if="!taskid">
            <div class="num">
                <img src="./img/icon1.png"
                     class="icon" />
                <p>已选（{{count}}题）</p>
            </div>
            <div class="btn"
                 :class="count>0?'active':''"
                 @click="next">去发布</div>
        </div>
    </div>
</template>

<script>
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    data () {
        return {
            title: '习题预览',
            ch_id: localStorage.getItem('ch_id') || '',
            count: 0,
            list: [],
            taskid: this.$route.params.taskid,
        }
    },
    components: {
        headers, loadingS, noResouse
    },
    created () {
        if (this.taskid) {
            this.get_task_detail()
        } else {
            this.get_question(this.ch_id)
        }

    },
    methods: {
        get_task_detail () {
            this.$http.post(API_URL_TASK_API + '/szyz/make/weiqi/detail', { message_id: this.taskid }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.loading = true;
                    this.count = res.data.length
                    res.data.forEach(item => {
                        if (item.title_type == 2) {
                            item.open = true
                        }
                    })
                    this.list = res.data
                }
            })
        },
        get_question (ids) {
            this.$http.post(API_URL_TASK_API + '/weiqi/chapter/question/', { chapter_id: ids, send_task: 1 }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.loading = true;
                    res.data.forEach(item => {
                        item.choise = false;
                        if (item.title_type == 2) {
                            item.open = false
                        }
                    })
                    this.list = res.data
                }
            })
        },
        remove (item) {
            if (item.choise) {
                this.count--
            } else {
                this.count++
            }
            item.choise = !item.choise
        },
        open (item) {
            item.open = !item.open
        },
        next () {
            if (this.count < 1) {
                return
            }
            let ids = []
            this.list.forEach(e => {
                if (e.choise) {
                    ids.push(e.id)
                }
            })
            console.log(ids)
            localStorage.setItem('wq_ids', JSON.stringify(ids))
            this.$router.push('/weiqi/release')
        },

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.weiqi_preview {
    padding-bottom: 120px / $ppr;
    &.pb0 {
        padding-bottom: 0;
    }
}
.topicSwitch {
    position: fixed;
    top: 96px / $ppr;
    left: 0;
    width: 100%;
    z-index: 8;
    .sum {
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        font-weight: bold;
        color: #333;
        background: #fff;
    }
}
.question_list {
    padding-top: 96px / $ppr;
    .question_item {
        position: relative;
        margin-top: 24px / $ppr;
        background: #fff;
        .title {
            display: flex;
            align-items: center;
            padding: 32px / $ppr 24px / $ppr;
            border-bottom: 1px / $ppr solid #e8e8e8;
            .icon {
                width: 26px / $ppr;
                height: 35px / $ppr;
                margin-right: 10px / $ppr;
            }
            p {
                flex: 1;
                /deep/ p {
                    display: inline;
                }
            }
        }
        .con {
            padding: 32px / $ppr 24px / $ppr;
            border-bottom: 1px / $ppr solid #e8e8e8;
            /deep/img {
                display: block;
            }
            /deep/p {
                padding-bottom: 20px / $ppr;
            }
        }
        .options {
            .tit {
                padding: 32px / $ppr 24px / $ppr;
                display: flex;
                align-items: center;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p {
                    color: #5e89ef;
                    font-size: 30px / $ppr;
                    margin-right: 10px / $ppr;
                }
                .icon {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                }
            }
            .ops_item {
                padding: 32px / $ppr 24px / $ppr;
                display: flex;
                align-items: center;
                border-bottom: 1px / $ppr solid #e8e8e8;
                .icon {
                    font-size: 30px / $ppr;
                    width: 48px / $ppr;
                    height: 48px / $ppr;
                    text-align: center;
                    line-height: 48px / $ppr;
                    border: 1px / $ppr solid #e8e8e8;
                    border-radius: 50%;
                    margin-right: 20px / $ppr;
                }
                p {
                    font-size: 30px / $ppr;
                }
                &.active {
                    .icon {
                        background: #66cc22;
                        color: #fff;
                    }
                    div {
                        color: #66cc22;
                    }
                }
            }
        }
        .times {
            padding: 24px / $ppr;
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 24px / $ppr;
                line-height: 1;
                color: #999;
            }
            .btn {
                width: 120px / $ppr;
                height: 48px / $ppr;
                line-height: 52px / $ppr;
                font-size: 24px / $ppr;
                text-align: center;
                border: 1px / $ppr solid #5e89ef;
                color: #5e89ef;
                border-radius: 48px / $ppr;
                &.active {
                    border: 1px / $ppr solid #f60;
                    color: #ff6600;
                }
            }
        }
    }
}
.next {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f0f0f0;
    .num {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
            width: 50px / $ppr;
            height: 42px / $ppr;
            margin-right: 10px / $ppr;
        }
        p {
            font-size: 30px / $ppr;
            color: #333;
        }
    }
    .btn {
        width: 216px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        background: #ccc;
        &.active {
            background: #5e89ef;
        }
    }
}
</style>